import { Button } from 'antd';
import hubLayout from 'styles/css/hubLayout.module.css';
import { useEffect, useRef, useState } from 'react';

import './style.css';

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="19"
      viewBox="0 0 13 19"
      fill="none"
    >
      <path
        d="M0.722656 8.87327L4.49255 12.6432L11.2763 5.85938"
        stroke="#39383D"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function VideoQualityButton({viewerQuality, onChangeVideoQuality}: {viewerQuality: number, onChangeVideoQuality: any}) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!isOpen) return;

    const handleClickEvent = (e: MouseEvent) => {
      const target = e.target as Node; // 또는 HTMLElement
      if (dropdownRef.current && !dropdownRef.current.contains(target)) {
        setIsOpen(false);
      }
    };

    window.addEventListener('click', handleClickEvent);

    return () => {
      window.removeEventListener('click', handleClickEvent);
    };
  }, [isOpen]);
  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      {isOpen && (
        <div ref={dropdownRef} className="video-quality-dropdown-container">
          <div
            className="video-quality-dropdown-row"
            onClick={() => {
              onChangeVideoQuality(false);
              setIsOpen(false);
            }}
          >
            {viewerQuality === 0 ? (
              <CheckIcon />
            ) : (
              <div
                style={{
                  width: '13px',
                }}
              />
            )}
            <span>저해상도</span>
          </div>
          <div
            className="video-quality-dropdown-row"
            onClick={() => {
              onChangeVideoQuality(true);
              setIsOpen(false);
            }}
          >
            {viewerQuality === 1 ? <CheckIcon /> : null}
            <span>고해상도</span>
          </div>
        </div>
      )}

      <Button
        type="text"
        className={`${hubLayout.controllers_wrap}`}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <div
          className={`${hubLayout.controllers} ${hubLayout.controllers_setting} `}
          style={{
            width: '24px',
            height: '24px',
          }}
        />
      </Button>
    </div>
  );
}
